import { AvatarNew, PillBadge } from '@platform/components';
import { Link } from 'wouter';
import { ROUTES } from '../../routes/consts';
import { ProjectType } from '../../dashboard/my-projects';
import { HubOrganization, HubProject, HubStatusEnum } from '@platform/client/schemas';
import { StatusBadge } from './StatusBadge';

// type ProjectDetailsSectionProps = ProjectDetails & { isTeam?: boolean };
type ProjectDetailsSectionPropsV2 = {
  organization: HubOrganization;
  status: HubStatusEnum;
  isTeam?: boolean;
  project?: HubProject;
};

export const ProjectDetailsSection = (props: ProjectDetailsSectionPropsV2) => {
  const { project, organization } = props;
  return (
    <div className='flex flex-col md:flex-row justify-center md:justify-start items-center gap-4 text-center md:text-left'>
      <div className='h-[84px] w-[84px]'>
        <AvatarNew url={organization?.avatar} fallbackIcon='building-04' withPadding />
      </div>
      <div className='flex flex-col gap-2'>
        <div className='flex gap-1 justify-center md:justify-start'>
          <StatusBadge status={props.status} />
          <PillBadge size='sm' color='blue' variant='plain'>
            {project?.roleType ? ProjectType[project?.roleType] : 'Custom'}
          </PillBadge>
        </div>
        {project && (
          <div className='text-display-xs font-medium text-brand-500'>
            <Link to={`${ROUTES.DIRECTORY}/projects/${project?.id}`}>{project?.name}</Link>
          </div>
        )}
        {!project && <div className='text-display-xs font-medium'>Custom Project</div>}
        <div className='text-lg text-brand-600'>
          <Link to={`${ROUTES.DIRECTORY}/organizations/${organization?.id}`}>
            {organization?.name}
          </Link>
        </div>
      </div>
    </div>
  );
};
